import Vue from 'vue'
import VueRouter from 'vue-router'

import Applications from '../views/Applications.vue'
import Application from '../views/Application.vue'
import Billing from '../views/Billing.vue'
import Pricing from '../views/Pricing.vue'
import Profile from '../views/Profile.vue'
import Support from '../views/Support.vue'
import Lexicons from '../views/Lexicons.vue'
import LexiconWords from '../views/LexiconWords'
import LexiconEdit from '../views/LexiconEdit'
import LexiconWordsAdd from '../views/LexiconWordsAdd'
import LexiconWordsView from '../views/LexiconWordsView'
import LexiconWordsEdit from '../views/LexiconWordsEdit'
import LexiconBuildsManagement from '../views/LexiconBuildsManagement'
import LexiconSuggestionsManagement from '../views/LexiconSuggestionsManagement'
import LexiconSuggestionWords from '../views/LexiconSuggestionWords'
import LexiconSuggestionAdd from '../views/LexiconSuggestionAdd'
import LexiconTranscribeManagement from '../views/LexiconTranscribeManagement'
import Translate from '../views/Translate.vue'
import TranslateText from '../views/TranslateText.vue'
import TranslateDocs from '../views/TranslateDocs.vue'
import TranslateTasks from '../views/TranslateTasks.vue'
import Transcribe from '../views/Transcribe.vue'
import TranscribeFiles from '../views/TranscribeFiles.vue'
import Home from '../views/Home.vue'

// Dyanmic imports
// import Usage from '../views/Usage.vue'
const Usage = () => import('@/views/Usage')

Vue.use(VueRouter)

function makeMeta (title = '', description = '') {
  description = description || title
  return {
    title: 'Apptek | ' + (title || 'Account management'),
    metaTags: [
      {
        name: 'description',
        content: description
      },
      {
        property: 'og:description',
        content: description
      }
    ]
  }
}

const routes = [
  {
    path: '/home',
    component: Home,
    meta: makeMeta()
  },
  {
    path: '/',
    name: 'home',
    component: Applications
  },
  {
    path: '/lexicons',
    name: 'Lexicons',
    component: Lexicons
  },
  {
    path: '/lexicons/words/:id',
    name: 'LexiconWords',
    component: LexiconWords
  },
  {
    path: '/lexicons/edit/:id',
    name: 'LexiconEdit',
    component: LexiconEdit
  },
  {
    path: '/lexicons/words/add/:id',
    name: 'LexiconWordsAdd',
    component: LexiconWordsAdd
  },
  {
    path: '/lexicons/words/view/:id',
    name: 'LexiconWordsView',
    component: LexiconWordsView
  },
  {
    path: '/lexicons/words/edit/:id',
    name: 'LexiconWordsEdit',
    component: LexiconWordsEdit
  },
  {
    path: '/lexicons/builds/manage/:id',
    name: 'LexiconBuildsManagement',
    component: LexiconBuildsManagement
  },
  {
    path: '/lexicons/suggestions/manage/:id',
    name: 'LexiconSuggestionsManagement',
    component: LexiconSuggestionsManagement
  },
  {
    path: '/lexicons/suggestions/words/:id',
    name: 'LexiconSuggestionWords',
    component: LexiconSuggestionWords
  },
  {
    path: '/lexicons/suggestions/add/:id',
    name: 'LexiconSuggestionAdd',
    component: LexiconSuggestionAdd
  },
  {
    path: '/lexicons/transcribe-management',
    name: 'LexiconTranscribeManagement',
    component: LexiconTranscribeManagement
  },
  {
    path: '/apps',
    name: 'Apps',
    component: Applications,
    meta: makeMeta('Applications and API Keys')
  },
  {
    path: '/apps/:id?',
    name: 'Application',
    component: Application,
    props: true
  },
  {
    path: '/billing',
    name: 'Billing',
    component: Billing,
    meta: makeMeta('Billing')
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: Pricing,
    meta: makeMeta('Pricing')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: makeMeta('Profile')
  },
  {
    path: '/support',
    name: 'Support',
    component: Support,
    meta: makeMeta('Contact support')
  },
  {
    path: '/translate',
    name: 'Translate',
    component: Translate,
    meta: makeMeta('Translate'),
    children: [
      { path: 'text', component: TranslateText },
      { path: 'docs', component: TranslateDocs },
      { path: 'tasks', component: TranslateTasks }
    ]
  },
  {
    path: '/transcribe',
    name: 'Transcribe',
    component: Transcribe,
    meta: makeMeta('Transcribe (speech to text)'),
    children: [
      { path: 'files', component: TranscribeFiles }
    ]
  },
  {
    path: '/usage',
    name: 'Usage',
    component: Usage,
    meta: makeMeta('Account usage')
  },
  {
    path: '/docs',
    // eslint-disable-next-line no-unused-vars
    beforeEnter (to, from, next) {
      window.location = 'https://docs.apptek.com/'
    }
  },
  {
    path: '/login',
    beforeEnter (to, from, next) {
      const url = `${process.env.VUE_APP_AUTH_LOGIN_URL}?next=${process.env.VUE_APP_SITE_BASE_URL}`
      window.location = url
    }
  },
  {
    path: '/logout',
    // eslint-disable-next-line no-unused-vars
    beforeEnter (to, from, next) {
      const url = `${process.env.VUE_APP_AUTH_LOGOUT_URL}?next=${process.env.VUE_APP_SITE_BASE_URL}`
      window.location = url
    }
  },
  {
    path: '/add_payment_method',
    meta: makeMeta('Add payment method'),
    // eslint-disable-next-line no-unused-vars
    beforeEnter (to, from, next) {
      const url = `${process.env.VUE_APP_BLX_ADD_CC_URL}`
      window.location = url
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  updateTitleAndMeta(to, from, next)
  if (Vue.$cookies.isKey(process.env.VUE_APP_AUTH_COOKIE_NAME)) {
    return next()
  }
  const url = `${process.env.VUE_APP_AUTH_LOGIN_URL}?next=${process.env.VUE_APP_SITE_BASE_URL}`
  window.location = url
})

function updateTitleAndMeta (to, from, next) {
  // From https://www.digitalocean.com/community/tutorials/vuejs-vue-router-modify-head
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)
  // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)
  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title
  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))
  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return
  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta')
    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key])
    })
    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '')
    return tag
  }).forEach(tag => document.head.appendChild(tag))
}

export default router
